<template>
	<bernstein-header> </bernstein-header>
	<Head title="Log in" />

	<jet-authentication-card>
		<!-- <template #logo>
            <jet-authentication-card-logo />
        </template> -->

		<jet-validation-errors class="mb-4" />

		<div v-if="status" class="mb-4 text-sm font-medium text-green-600">
			{{ status }}
		</div>

		<form @submit.prevent="submit">
			<div>
				<jet-label for="email" value="E-mail" />
				<jet-input
					id="email"
					type="email"
					class="mt-1 block w-full"
					v-model="form.email"
					required
					autofocus
				/>
			</div>

			<div class="mt-4">
				<jet-label for="password" value="Passwort" />
				<jet-input
					id="password"
					type="password"
					class="mt-1 block w-full"
					v-model="form.password"
					required
					autocomplete="current-password"
				/>
			</div>

			<div class="mt-4 block">
				<label class="flex items-center">
					<jet-checkbox name="remember" v-model:checked="form.remember" />
					<span class="ml-2 text-sm text-gray-600">Angemeldet bleiben</span>
				</label>
			</div>

			<div class="mt-4 flex items-center justify-end">
				<Link
					:href="route('register')"
					class="text-sm text-gray-600 underline hover:text-gray-900"
				>
					Register
				</Link>

				<!-- <Link 
                v-if="canResetPassword" 
                :href="route('password.request')" 
                class="underline text-sm text-gray-600 hover:text-gray-900">
                    Forgot your password?
                </Link> -->

				<jet-button
					class="ml-4"
					:class="{ 'opacity-25': form.processing }"
					:disabled="form.processing"
				>
					Log in
				</jet-button>
			</div>
			<div>
				<Link
					:href="route('password.request')"
					class="text-sm font-bold text-gray-900 underline hover:text-gray-900"
				>
					Passwort vergessen
				</Link>
			</div>
		</form>
	</jet-authentication-card>

	<bernstein-footer> </bernstein-footer>
</template>

<script>
import JetAuthenticationCard from "@/Jetstream/AuthenticationCard.vue";
import JetAuthenticationCardLogo from "@/Jetstream/AuthenticationCardLogo.vue";
import JetButton from "@/Jetstream/Button.vue";
import JetInput from "@/Jetstream/Input.vue";
import JetCheckbox from "@/Jetstream/Checkbox.vue";
import JetLabel from "@/Jetstream/Label.vue";
import JetValidationErrors from "@/Jetstream/ValidationErrors.vue";
import { Head, Link } from "@inertiajs/inertia-vue3";
import BernsteinHeader from "@/Jetstream/BernsteinHeader";
import BernsteinFooter from "@/Jetstream/BernsteinFooter";
export default {
	props: {
		canResetPassword: Boolean,
	},
	components: {
		Head,
		JetAuthenticationCard,
		JetAuthenticationCardLogo,
		JetButton,
		JetInput,
		JetCheckbox,
		JetLabel,
		JetValidationErrors,
		Link,
		BernsteinHeader,
		BernsteinFooter,
	},

	props: {
		canResetPassword: Boolean,
		status: String,
	},

	data() {
		return {
			form: this.$inertia.form({
				email: "",
				password: "",
				remember: false,
			}),
		};
	},

	methods: {
		submit() {
			this.form
				.transform((data) => ({
					...data,
					remember: this.form.remember ? "on" : "",
				}))
				.post(this.route("login"), {
					onFinish: () => this.form.reset("password"),
				});
		},
	},
};
</script>
